import { defineComponent, onBeforeUnmount, ref, watch } from 'vue'
import type { DropdownProps } from './types'
import DropdownItem from './components/dropdown-item'
import { useInterpolation } from '@/utils/animation/useInterpolation'
import { onClickOutside } from '@vueuse/core'

const Dropdown = defineComponent<DropdownProps>({
  setup(props) {
    const interp = useInterpolation({
      duration: 0.15,
      initial: 0
    })

    const unwatch = watch(
      () => props.expanded,
      (expanded) => {
        interp.runTo(expanded ? 1.0 : 0.0)
      },
      { immediate: true }
    )

    onBeforeUnmount(unwatch)

    const elRef = ref();

    onClickOutside(elRef, () => {
      if (props.expanded) {
        if (props.setExpanded) {
          props.setExpanded(false);
        }
      }
    }, { ignore: props.triggerRef ? [props.triggerRef] : undefined });

    return () => {
      return (
        <div
          ref={elRef}
          class="bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-60 dark:bg-gray-700 dark:divide-gray-600"
          style={{
            userSelect: 'none',
            position: 'absolute',
            top: 3.25 + -(1.0 - interp.state.value) * 2.0 + 'rem',
            right: 0,
            opacity: `${interp.state.value * 100}%`,
            ...(props.expanded
              ? {}
              : {
                  //display: 'none',
                  pointerEvents: 'none'
                })
          }}
        >
          {props.header && (
            <div class="px-4 py-3 text-sm text-gray-900 dark:text-white">
              <div class="font-semibold text-gray-900">{props.header.title}</div>
              {props.header.subtitle && (
                <div class="font-normal text-gray-500 truncate">{props.header.subtitle}</div>
              )}
            </div>
          )}

          {(props.groups || []).map((group) => {
            return (
              <ul
                class="py-2 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownInformationButton"
              >
                {(group.items || []).map((item, i) => {
                  return <DropdownItem key={`dropdown-group-${item.label ?? i}`} item={item} />
                })}
              </ul>
            )
          })}
        </div>
      )
    }
  }
})

Dropdown.props = ['header', 'groups', 'expanded', 'setExpanded', 'triggerRef']

export default Dropdown
